module.exports = __webpack_public_path__ + "img/logo-01.2959d12b.png";